import { Typography } from '@mui/material'

export const BoxTextField = ({ value = "" }) => {
    return (
        <Typography
            sx={{
                border: "1px solid #bbbbbbff",
                padding: "7px 14px",
                bgcolor: "#f5f5f5ff",
                fontSize: 16,
                minHeight: 40,
                borderRadius: 1,
            }}  >
            {value}
        </Typography>
    )
}
